import React from 'react'
import { Propeties } from '../../components/Properties'

export const ProperPage = () => {
  return (
    <Propeties>ProperPage</Propeties>
  )
}
